import './i18n';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { AuthContextProvider } from "./context/AuthContext";
import { initRewardful } from "./utils/rewardful";
import { initAnalytics } from "./utils/analytics";

// Capture the Rewardful referral UUID as soon as the script is ready, so
// affiliate (OWN) conversions attribute reliably regardless of click timing.
initRewardful();
// PostHog (no-op until its project key is set — see utils/analytics.js).
initAnalytics();

ReactDOM.render(
  <AuthContextProvider>
    <App />
  </AuthContextProvider>,
  document.getElementById('root')
);

// Hide splash as soon as the first frame is painted
window.requestAnimationFrame(() => {
  const el = document.getElementById('splash');
  if (el) el.classList.add('splash--hide');
});
